import { Modal, ModalHeader } from "@joonapp/web-shared"
import { useEffect } from "react"

import AllQuestsMultiSelectActions from "./AllQuestsMultiSelectActions.tsx"
import { useAllQuestsModalStore } from "./hooks/useAllQuestsModalStore.ts"
import useAllQuestsMultiSelectStore from "./hooks/useAllQuestsMultiSelectStore.tsx"
import { useQuestDndSectionsStore } from "./hooks/useQuestDndSectionsStore.ts"
import InactiveQuestsSection from "./InactiveQuestsSection.tsx"
import QuestDndList from "./QuestDndList.tsx"
import SaveDndQuestOrderButton from "./SaveDndQuestOrderButton.tsx"
import SearchInput from "./SearchInput.tsx"
import useMobile from "../../../hooks/useMobile.ts"
import QuestBoardUserSelectHeader from "../QuestBoardUserSelectHeader.tsx"
import useQuestBoardStore from "../useQuestBoardStore.ts"

const AllQuestsModal = () => {
  const { isOpen, onClose } = useAllQuestsModalStore()
  const { userHasMadeChanges } = useQuestDndSectionsStore()
  const { selectedUserId } = useQuestBoardStore()
  const isMobile = useMobile()
  const { selectedQuestSeriesIds } = useAllQuestsMultiSelectStore()

  useEffect(() => {
    document.getElementById("quests-dnd-list")?.scrollTo(0, 0)
  }, [selectedUserId])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      mobileFull
      style={{ height: "100dvh", width: "min(600px, 100%)" }}
      animate
    >
      <div className="flex flex-col justify-between">
        <ModalHeader onClose={onClose} title="All Quests" showBorderBottom />
        <div className={`p-3${isMobile ? " px-0" : ""} shadow-sm`}>
          <QuestBoardUserSelectHeader />
        </div>
        <div
          id="quests-dnd-list"
          className="px-4 pb-3 pr-3 pt-4 overflow-y-auto overflow-x-hidden w-full"
          style={{
            height: `calc(100dvh - 88px - 57px - ${
              selectedQuestSeriesIds.length > 0 ? "133px" : "0px"
            }${userHasMadeChanges ? " - 71px" : ""})`,
            transition: "height 0.2s ease",
          }}
        >
          <SearchInput />
          <InactiveQuestsSection />
          <QuestDndList />
        </div>
        <SaveDndQuestOrderButton />
        <AllQuestsMultiSelectActions />
      </div>
    </Modal>
  )
}

export default AllQuestsModal
